import DataAsesmenRisikoJatuh from "@/services/DataAsesmenRisikoJatuh";

import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";

import store from "@/store";
import { appModule } from "./app";

@Module({ store, dynamic: true, name: "storeAssesmenRisikoJatuh" })
class StoreAssesmenRisikoJatuh extends VuexModule {
  riwayatRisikoJatuh = [];
  asesmenRisikoJatuh = {};

  @Mutation SET_ASSESMEN_RISIKO_JATUH(asesmenRisikoJatuh: {}) {
    this.asesmenRisikoJatuh = asesmenRisikoJatuh;
  }

  @Mutation SET_RIWAYAT_RISIKO_JATUH(riwayatRisikoJatuh = []) {
    this.riwayatRisikoJatuh = riwayatRisikoJatuh;
  }

  @Action actAsesmenRisikoJatuh(param) {
    const dt = DataAsesmenRisikoJatuh.getDataAsesmenRisikoJatuh(param["unit_id"], param["reg"]);
    // appModule.setLoading(true);
    dt.then(dt => {
      // appModule.setLoading(false);
      const detail = dt.data;
      this.SET_ASSESMEN_RISIKO_JATUH(detail);
    });
  }

  @Action actRiwayatRisikoJatuh(rm) {
    const dt = DataAsesmenRisikoJatuh.getDataRiwayatAsesmenRisikoJatuh(rm);
    appModule.setLoading(true);
    dt.then(dt => {
      appModule.setLoading(false);
      const data = dt.data;
      this.SET_RIWAYAT_RISIKO_JATUH(data);
    });
  }
}

export const storeAssesmenRisikoJatuh = getModule(StoreAssesmenRisikoJatuh);
